import React from 'react';
import PropTypes from 'prop-types';

import { StyledSelect } from './styles';

// * Prefix {string} A prefix for all classes on the pkg select
// * Label {string} The value that displays as a placeholder on the select dropdown
// * Options {Array} An array of objects that create the select options
// * DefaultOptions {Obj} A single option that should be the defaultSelect dropdown option
// * onChange (Func) Called whenever a value changes, and passes back the object of the selected option

function Select({
  className,
  options,
  defaultOption,
  label,
  isDisabled,
  prefix,
  state,
  setState,
}) {
  if (!options) return null;

  const handleChange = (option) => {
    setState(option);
  };

  return (
    <StyledSelect
      className={className}
      classNamePrefix={prefix}
      value={state}
      onChange={handleChange}
      options={options}
      placeholder={label}
      isDisabled={isDisabled}
      defaultOption={defaultOption}
      isSearchable={false}
      isClearable={false}
      menuPortalTarget={
        typeof document !== 'undefined'
          ? document.getElementById('portal')
          : null
      }
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 2 }) }}
    />
  );
}

Select.propTypes = {
  className: PropTypes.string,
  prefix: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  defaultOption: PropTypes.shape(),
  label: PropTypes.string,
  isDisabled: PropTypes.bool,
  setState: PropTypes.func,
  state: PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.bool,
  ]),
};

Select.defaultProps = {
  className: null,
  prefix: 'react-select',
  defaultOption: null,
  label: null,
  isDisabled: false,
  setState: null,
  state: null,
};

export default Select;
